<template>
  <PaymentFormSelect
    v-model="receiverId"
    label="Collected by"
    placeholder="Who collected the payment?"
    :options="receiverOptions"
    :error-message="errorMessage"
    data-cy="collected-by"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import PaymentFormSelect from "@/components/PaymentModals/PaymentFormSelect.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import usePaymentMethods from "./usePaymentMethods";

const props = defineProps<{
  modelValue: number | string | null;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: number | string | null): void;
}>();

const { receivers } = usePaymentMethods();

const receiverId = computed({
  get: () => (props.modelValue ?? "") as string,
  set: (val) => emit("update:modelValue", val)
});

const receiverOptions = computed(() =>
  receivers.value.map((receiver: any) => ({
    value: `${receiver.id}_${receiver.type}`,
    label: receiver.full_name
  }))
);

const v$ = useVuelidate(
  { receiverId: { required, $autoDirty: true } },
  { receiverId }
);
const errorMessage = computed(() => firstErrorMessage(v$.value.receiverId));
</script>
